<template>
  <div>
    <!-- <DialogComponent
			:visible.sync="isArticle"
			class="article"
			:width="articleData.contentType === 1 ? '800px' : '976px'"
			:height="'70%'"
		> -->
    <el-dialog
      :visible.sync="isArticle"
      class="article"
      append-to-body
      :width="$device.mobile ? '100%' : '30%'"
      :height="'70%'"
    >
      <ArticleContent
        :content="articleData.content"
        :type="articleData.type"
        :time="articleData.readTime"
        :title="articleData.name"
        :content-type="articleData.contentType"
        :url="articleData.fileUrl"
      />
      <template #footer>
        <!-- 展示点击签名区域start -->
        <div v-if="handleisshow && articleData.type === 1" class="mb-6 footer">
          <div class="flex justify-between">
            <div style="font-size: 16px">{{ $t('Personal.Signature') }}：</div>
            <el-link v-if="!esignvisible && handleisbtn" type="primary" @click="handleresetgloba">
              {{ $t('Personal.Reset') }}
            </el-link>
            <el-link v-if="esignvisible" class="ml-12" @click="handleopensign">
              {{ $t('Personal.Clicktosign') }}
            </el-link>
          </div>
          <div v-if="esignimg" class="flex justify-start">
            <el-image class="w-180 h-60" :src="esignimg" :preview-src-list="[esignimg]" />
          </div>
        </div>
        <!-- 展示点击签名区域end -->
        <!-- 展示上传图片组件start -->
        <div v-if="articleData.type === 2" class="sign flex justify-between">
          <div style="font-size: 16px" class="label">{{ $t('Personal.Upload') }}：</div>
          <div class="startsign">
            <el-upload
              :action="uploadUrl"
              :on-preview="handlePreview"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="handleSuccess"
              multiple
              :disabled="!!articleData.read"
              :limit="articleData.filesCount"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :show-file-list="false"
            >
              <el-button
                :class="['uploadBtn']"
                size="small"
                :type="articleData.filesCount === fileList.length || !!articleData.read ? 'default' : 'primary'"
              >
                {{ $t('Personal.ClickToUpload') }} <br />
                {{ fileList.length || 0 }}/{{ articleData.filesCount }}
              </el-button>
              <template #tip>
                <div class="el-upload__tip">
                  {{ $t('Personal.UploadRules') }}
                </div>
              </template>
            </el-upload>
          </div>
        </div>
        <!-- 展示上传图片组件end -->
        <div>
          <i v-if="String(articleData.read) === '1'" class="time">{{ articleData.readTime }}</i>
          <el-button v-if="articleData.type === 'msg'" class="ml-12" type="warning" @click="isArticle = false">{{
            $t('dialog.shutDown')
          }}</el-button>
          <el-button
            v-else
            class="ml-12"
            :type="String(articleData.read) === '0' ? 'primary' : 'default'"
            @click="post_readprot"
          >
            {{ $t('productList.confirmed') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <!-- </DialogComponent> -->
    <!-- 签名组件 -->
    <!-- <DialogComponent
      :show-close="false"
      append-to-body
      :title="$t('Personal.Signature')"
      :visible.sync="dialogVisible"
      :width="'40%'"
    > -->
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :width="$device.mobile ? '100%' : '30%'"
      :height="'70%'"
      class="signature-dialog"
    >
      <div v-loading="loading">
        <vue-esign
          v-show="esignvisible"
          ref="esign"
          :width="esignWidth"
          :height="esignHeight"
          style="border-bottom: 1px solid var(--border-color)"
        />
        <div v-show="!esignvisible" class="!h-full !w-full">
          <view-image :file-list="[esignimg]" class="!h-300 !w-full" />
        </div>
      </div>
      <template #footer>
        <div class="bottom-footer three">
          <div>
            <el-button @click="handleclose">{{ $t('Promote.cancel') }}</el-button>
          </div>
          <div>
            <el-button type="warning" @click="handleReset">{{ $t('Personal.Reset') }}</el-button>
          </div>
          <div>
            <el-button type="primary" @click="handleGenerate">{{ $t('Personal.Confirm') }}</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <!-- </DialogComponent> -->
  </div>
</template>
<script>
// import DialogComponent from './dialog-component.vue'
import viewImage from './viewImage.vue'
import ArticleContent from '@/components/common/message/content.vue'
export default {
  name: 'MyArticle',
  components: {
    // DialogComponent,
    viewImage,
    ArticleContent
  },
  props: {
    message: {
      type: Object,
      default: () => {}
    },
    saveDirect: Boolean
  },
  data() {
    return {
      isArticle: false,
      loading: false, // 加载动画 点击确定时加载
      type: '', // 控制是个人信息的阅读同意 agree 还是共用的信息弹框  msg
      articleData: '',
      esignimg: '', // 签名，之后显示的图片 也是要上传的url
      dialogVisible: false, // 控制签名弹框的显示隐藏
      esignvisible: true, // 控制签名前和签名后的显示隐藏
      fileList: [],
      uploadUrl: '/picupload',
      selFile: {},
      articleType: 1
    }
  },
  computed: {
    // 如果 已经阅读 且articleData.signatureUrl没有 也就是没有签过名的也要 隐藏签名组件
    handleisshow() {
      const state = String(this.articleData.read) === '1' && !this.articleData.signatureUrl ? false : true
      return state
    },
    // 重置按钮 显示隐藏逻辑 如果已经阅读 且 已经签名的 隐藏重置按钮
    handleisbtn() {
      const state = String(this.articleData.read) === '1' && this.articleData.signatureUrl ? false : true
      return state
    },
    esignWidth() {
      return this.$device.mobile ? window.innerWidth - 48 : 800
    },
    esignHeight() {
      return this.$device.mobile ? window.innerHeight / 2 - 48 : 410
    }
  },
  watch: {
    message(val) {
      this.articleData = val
      if (val.type === 2) {
        try {
          this.fileList = JSON.parse(val.enclosureUrl || '[]')
        } catch (e) {
          console.log(e)
        }
      }
      this.isArticle = val.isDialog
    },
    articleData(val) {
      if (val.signatureUrl) {
        this.esignvisible = false
        this.esignimg = val.signatureUrl
      } else {
        this.esignvisible = true
        this.esignimg = val.signatureUrl
      }
    }
  },
  mounted() {
    this.$watch('isArticle', (e) => {
      if (!e) this.fileList = []
    })
  },
  methods: {
    handleRemove(file, fileList) {
      this.filterFileList(fileList)
    },
    handlePreview(file) {
      this.$global.download_path(file)
    },
    handleExceed() {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${this.limit} 个文件，共选择了 ${this.limit + fileList.length} 个文件`);
    },
    beforeRemove() {
      return true // this.$confirm(`确定移除 ${ file.name }？`);
    },
    beforeUpload(file) {
      const types = ['png', 'jpg', 'pdf', 'doc', 'docx']
      const fileExt = file.name.replace(/.+\./, '').toLowerCase()
      const isLt10M = file.size / 1024 / 1024 < 10
      let bool = file
      if (types.indexOf(fileExt) === -1) bool = false
      if (!isLt10M) bool = false
      if (!bool) this.$message.warning(this.$t('Personal.UploadRules'))
      return bool
    },
    handleSuccess(data, file, fileList) {
      if (data.code === 0) {
        this.filterFileList(fileList)
      }
    },

    filterFileList(fileList) {
      this.fileList = fileList.map((item) => {
        item.fileName = item.response.fileName
        item.url = item.response.url
        return item
      })
    },

    // 打开签名组件
    handleopensign() {
      this.dialogVisible = true
    },
    // 重置画板
    handleReset() {
      this.$refs.esign.reset()
    },
    // 关闭并重置
    handleclose() {
      this.$refs.esign.reset()
      this.dialogVisible = false
    },
    // 点击重置状态 恢复到写签名之前
    handleresetgloba() {
      this.esignimg = ''
      this.esignvisible = true
      this.handleReset()
    },
    // 导出base64图片
    handleGenerate() {
      this.loading = true
      this.$refs.esign
        .generate()
        .then((res) => {
          const blob = this.dataURLtoBlob(res)
          const tofile = this.blobToFile(blob, '1.jpg')
          setTimeout(async () => {
            const formData = new FormData()
            formData.append('file', tofile, tofile.name)
            formData.append('fileType', 9)
            this.$ajax.post(this.uploadUrl, formData).then((data) => {
              this.esignvisible = false
              this.dialogVisible = false
              this.esignimg = data.url
              // eslint-disable-next-line max-nested-callbacks
              setTimeout(() => {
                this.loading = false
              }, 2000)
            })
          })
        })
        .catch(() => {
          this.loading = false
          this.$message.error(this.$t('Commons.enter') + this.$t('Personal.Signature'))
        })
    },
    // 将base64转成
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    // 点击已阅读并同意
    post_readprot() {
      if (this.articleData.type === 1 && String(this.articleData.read) === '0' && !this.esignimg) {
        const status = 'error'
        this.$message({
          message: this.$t('Personal.Signatureisrequired'),
          type: status,
          duration: 1000
        })
        return false
      }
      if (this.articleData.type === 2 && !this.fileList.length) {
        const status = 'error'
        this.$message({
          message: this.$t('Personal.PleaseUpload'),
          type: status,
          duration: 1000
        })
        return false
      }
      const param = {
        protocolId: this.articleData.protocolId
      }
      if (this.articleData.type === 1) param.signatureUrl = this.esignimg
      if (this.articleData.type === 2)
        param.enclosureUrl = JSON.stringify(
          this.fileList.map((item) => {
            return { name: item.name, url: item.url }
          })
        )
      if (!this.saveDirect) {
        this.$emit('read', param) // 成功后传值给对应组件改变值内容
        this.isArticle = false
        return
      }
      this.$axios.post('/user/readprot', param).then(({ code, data, msg }) => {
        if (code !== 0) {
          return
        } else {
          this.$emit('read', param) // 成功后传值给对应组件改变值内容
          this.isArticle = false
          const status = 'success'
          this.$message({
            message: msg || data?.msg,
            type: status,
            duration: 1000
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.article {
  /* stylelint-disable-next-line selector-class-pattern */
  ::v-deep .el-dialog__header {
    padding: 0 !important;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  ::v-deep .el-dialog__body {
    padding: 0 !important;
    margin-top: -21px;
    overflow: hidden;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  ::v-deep .el-dialog__headerbtn {
    z-index: 9999;
  }
}

.signature-dialog {
  /* stylelint-disable-next-line selector-class-pattern */
  ::v-deep .el-dialog__footer {
    padding: 18px 24px;
    background: theme('colors.bgColor.module');
    border-top: 1px solid theme('colors.divide');

    .bottom-footer {
      display: grid;
      // grid-template-columns: 1fr 1fr;
      gap: 12px;
      width: 100%;

      &:has(> div:nth-child(1)) {
        grid-template-columns: 1fr;
      }

      &:has(> div:nth-child(2)) {
        grid-template-columns: 1fr 1fr;
      }

      &:has(> div:nth-child(3)) {
        grid-template-columns: 1fr 1fr 1fr;
      }

      > div {
        margin-left: 0;

        .el-button {
          width: 100%;
          height: 40px;
        }
      }

      &.one {
        grid-template-columns: 1fr;
      }

      &.two {
        grid-template-columns: 1fr 1fr;
      }

      &.three {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }
}
</style>
